<template>
  <div class="admin-layout">
    <header class="admin-topbar">
      <div class="admin-topbar-left">
        <h2 class="admin-page-title">{{ pageTitle }}</h2>

        <nav class="admin-nav" aria-label="Admin navigation">
          <router-link to="/admin/dashboard" class="admin-nav-item" active-class="admin-nav-active" title="Dashboard" aria-label="Dashboard">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="3" width="7" height="7" rx="1"/>
              <rect x="3" y="14" width="7" height="7" rx="1"/>
              <rect x="14" y="14" width="7" height="7" rx="1"/>
            </svg>
          </router-link>

          <router-link to="/admin/accounts" class="admin-nav-item" active-class="admin-nav-active" title="Accounts" aria-label="Accounts">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          </router-link>

          <router-link to="/admin/licenses" class="admin-nav-item" active-class="admin-nav-active" title="Licenses" aria-label="Licenses">
            <AppIcon name="bi-key" class="bi bi-key" />
          </router-link>

          <router-link to="/admin/announcements" class="admin-nav-item" active-class="admin-nav-active" title="Announcements" aria-label="Announcements">
            <AppIcon name="bi-megaphone" class="bi bi-megaphone" />
          </router-link>
        </nav>
      </div>

      <div class="admin-topbar-right">
        <button class="admin-logout-btn" @click="logout" title="Logout" aria-label="Logout">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    </header>

    <main class="admin-main">
      <div class="admin-content">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminLayout',
  computed: {
    pageTitle() {
      const titles = {
        'AdminDashboard': 'Dashboard',
        'AdminAccounts': 'Accounts',
        'AdminAccountDetails': 'Account Details',
        'AdminLicenses': 'Licenses',
        'AdminAnnouncements': 'Announcements'
      }
      return titles[this.$route.name] || 'Admin'
    }
  },
  async created() {
    if (!localStorage.getItem('admin_token')) {
      this.$router.push('/admin/login')
      return
    }
    try {
      // Verify token with backend
      await axios.get(`${process.env.VUE_APP_API}/admin/me`)
    } catch (e) {
      this.logout()
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      this.$router.push('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f4f7fb;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1f2937;
  max-width: 100vw;
  overflow-x: hidden;
}

.admin-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.admin-nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #64748b;
  text-decoration: none;
  font-size: 19px;
  transition: all 0.2s ease;
}

.admin-nav-item:hover {
  color: #111827;
  background: #f1f5f9;
}

.admin-nav-active {
  color: #3730a3 !important;
  background: #eef2ff !important;
}

.admin-nav-active svg,
.admin-nav-active i {
  color: #818cf8;
}

.admin-logout-btn {
  padding: 8px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
}

.admin-logout-btn:hover {
  color: #ef4444;
  background: #fef2f2;
  border-color: #fecaca;
}

/* Main */
.admin-main {
  flex: 1;
  margin-left: 0;
  min-height: calc(100vh - 65px);
  min-width: 0;
  width: 100%;
}

.admin-topbar {
  padding: 12px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 20;
}

.admin-topbar-left,
.admin-topbar-right {
  display: flex;
  align-items: center;
}

.admin-topbar-left {
  gap: 14px;
  min-width: 0;
}

.admin-topbar-right {
  gap: 14px;
}

.admin-page-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  letter-spacing: -0.3px;
}

.admin-content {
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .admin-main {
    margin-left: 0;
    width: 100%;
    max-width: 100vw;
  }

  .admin-topbar {
    padding: 16px 20px;
  }

  .admin-page-title {
    display: none;
  }

  .admin-content {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .admin-topbar {
    padding: 12px 16px;
  }
  
  .admin-content {
    padding: 16px 12px;
  }

  .admin-topbar-left {
    gap: 8px;
  }

  .admin-nav {
    margin-left: 0;
  }
}
</style>
